import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type Currency = 'BDT' | 'USD' | 'EUR'

interface CurrencyStore {
  currency: Currency
  setCurrency: (currency: Currency) => void
  getSymbol: () => string
  convert: (amount: number) => number
}

const EXCHANGE_RATES: Record<Currency, number> = {
  BDT: 1,
  USD: 0.0091, // 1 BDT = 0.0091 USD
  EUR: 0.0084, // 1 BDT = 0.0084 EUR
}

const CURRENCY_SYMBOLS: Record<Currency, string> = {
  BDT: '৳',
  USD: '$',
  EUR: '€',
}

export const useCurrencyStore = create<CurrencyStore>()(
  persist(
    (set, get) => ({
      currency: 'BDT',
      
      setCurrency: (currency: Currency) => {
        set({ currency })
      },
      
      getSymbol: () => {
        return CURRENCY_SYMBOLS[get().currency]
      },
      
      convert: (amount: number) => {
        const rate = EXCHANGE_RATES[get().currency]
        return Number((amount * rate).toFixed(2))
      },
    }),
    {
      name: 'BotTola-currency',
    }
  )
)
